import InformationBox from '../information-box/information-box';

const ContactUs = () => {
 window.scrollTo(0, 0);
  return (
    <div className="c-contact-us">
      <div className="c-contact-us--welcome">
        <p className="c-contact-us--welcome__text">To make an order, you can call us or order in-store. We do not deliver, so all orders must be picked-up from the store. Please see below for the relevant contact information.</p>
        <hr className="c-contact-us--welcome__seperator" />
      </div>
      <div className="c-contact-us--container">
        <InformationBox />
      </div>
    </div>
  );
}

export default ContactUs;